var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcnPortfolio = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.34375 3.5V2.15625H5.65625V3.5H8.34375ZM12.3438 3.5C12.7188 3.5 13.0312 3.63542 13.2812 3.90625C13.5312 4.15625 13.6562 4.46875 13.6562 4.84375V12.1562C13.6562 12.5312 13.5312 12.8542 13.2812 13.125C13.0312 13.375 12.7188 13.5 12.3438 13.5H1.65625C1.28125 13.5 0.96875 13.375 0.71875 13.125C0.46875 12.8542 0.34375 12.5312 0.34375 12.1562V4.84375C0.34375 4.46875 0.46875 4.15625 0.71875 3.90625C0.96875 3.63542 1.28125 3.5 1.65625 3.5H4.34375V2.15625C4.34375 1.78125 4.46875 1.46875 4.71875 1.21875C4.96875 0.96875 5.28125 0.84375 5.65625 0.84375H8.34375C8.71875 0.84375 9.03125 0.96875 9.28125 1.21875C9.53125 1.46875 9.65625 1.78125 9.65625 2.15625V3.5H12.3438Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcnPortfolio, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icn-portfolio.933c26e6.svg";
export { ForwardRef as ReactComponent };